import type { MessageInstance } from 'antd/es/message/interface'
import type { ModalStaticFunctions } from 'antd/es/modal/confirm'
import type { NotificationInstance } from 'antd/es/notification/interface'

/**
 * Holds references to Ant Design's context-aware imperative APIs.
 *
 * Populated by <AntdStaticApiProvider /> which sits inside <App>,
 * so every call inherits ConfigProvider tokens (colors, dark mode, etc.).
 *
 * Usage in non-component code:
 *   import { antdStaticApi } from './antd-static-api'
 *   antdStaticApi.modal.confirm({ title: '...' })
 */
export const antdStaticApi: {
    modal: Omit<ModalStaticFunctions, 'warn'>
    message: MessageInstance
    notification: NotificationInstance
} = {} as any
